import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=e1265ba6&"
import script from "./ImgUpload.vue?vue&type=script&lang=js&"
export * from "./ImgUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports